import { useMemo } from 'react';
import useAssignmentsNotificationCount from '../../../data/assignments/useAssignmentsNotificationCount';
import useUnreadConversationCount from '../../../data/conversation/useUnreadConversationCount';
import useLeadsUnreadCount from '../../../data/leads/useLeadsUnreadCount';
import useOnlineOrders from '../../../data/online-orders/useOnlineOrders';
import useUnhandledFormSubmissions from '../../../data/websites/useUnhandledFormSubmissions';

interface NotificationCounts {
  assignments?: number;
  leads?: number;
  messages?: number;
  orders?: number;
  websiteFormSubsmissions?: number;
}

const useNavigationNotifications = (): NotificationCounts => {
  const newAssignmentsCount = useAssignmentsNotificationCount();
  const [leadCount] = useLeadsUnreadCount();

  const [unreadMessagesCount] = useUnreadConversationCount();

  const [orders] = useOnlineOrders(['Created'], 100);
  const [unhandledFormSubmission] = useUnhandledFormSubmissions();

  const notifications = useMemo(
    () => ({
      assignments: newAssignmentsCount,
      leads: leadCount,
      messages: unreadMessagesCount,
      orders: orders?.length,
      websiteFormSubsmissions: unhandledFormSubmission?.count,
    }),
    [
      newAssignmentsCount,
      leadCount,
      unreadMessagesCount,
      orders?.length,
      unhandledFormSubmission?.count,
    ],
  );

  return notifications;
};

export default useNavigationNotifications;
